export default __webpack_public_path__ + "assets/c3d8beabc47980a89bc176a4b1183b40.png";